import { Button } from "@mui/material";
import { Component, useState } from "react";
import { useEffect } from "react";
import { FiSave } from "react-icons/fi";
import { FaTimes } from "react-icons/fa";
import { Form, Formik, FormikErrors, FormikHelpers, useFormikContext } from "formik";
import { useNavigate } from "react-router";
import { TiArrowBack } from "react-icons/ti";
import { PartnerDto, PartnerForCreationDto, PartnerForUpdateDto } from "../types";
import { partnerValidationSchema } from "../validation";
import FormFieldInput from "../../../components/Forms/FormFieldInput";
import FormatedTextEditor from "../../../components/Forms/FormatedTextEditor";
import { useAddPartner } from "../api/addPartners";
import { useUpdatePartner } from "../api/updatePartners";
import { LoadingButton } from '@mui/lab';
import { Notifications } from "../../../components/notifications";
import FormFieldDateTime from "../../../components/Forms/FormFiledDateTime";
import FormFieldCheckbox from "../../../components/Forms/FormFieldCheckbox";
import FormFieldTextArea from "../../../components/Forms/FormFieldTextArea";
import { useDisclosure } from "@mantine/hooks";
import { selectCurrentUser } from "../../../auth/AuthUserSlice";
import { useSelector } from "react-redux";
import { CheckIfExist } from "../../../App";
import FormField2Select from "../../../components/Forms/FormField2Select";
import { useTranslation } from "react-i18next";
import FormFieldCountrySelect from "../../../components/Forms/FormFieldCountrySelect/FormFieldCountrySelect";
import FormikStepper, { InputField } from "formik-stepper";
import FormikStep from "formik-stepper/dist/fromikForm/FormikStep";

import "formik-stepper/dist/style.css";

import Stepper from 'react-stepper-horizontal';
import moment from "moment";

interface Props {
  defaultPartner? : PartnerDto;
  close?: any;
}

interface SubmitPartnerProps {
  data: PartnerForCreationDto | PartnerForUpdateDto;
  formikHelpers: FormikHelpers<PartnerForCreationDto | PartnerForUpdateDto>;
}

interface FormikProps {
  isValid?: boolean;
  dirty?: boolean;
  errors?: FormikErrors<PartnerForCreationDto | PartnerForUpdateDto>;
  isSubmitting?: boolean;
  values?: PartnerForCreationDto | PartnerForUpdateDto;
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean | undefined) => Promise<void | FormikErrors<PartnerForCreationDto | PartnerForUpdateDto>>;
  handleReset?: () => void;
}

interface InfosProps {
  formikProps: FormikProps;
}

const PartnerForm = ({ defaultPartner, close } : Props) => {

  const currentUser = useSelector(selectCurrentUser);
  const {t, i18n} = useTranslation("common");
  const [visible, setVisible] = useState(false);
  const [validators, setValidators] = useState("");
  const navigate = useNavigate();
  const [partner, setPartner] = useState({
    emailAccount: defaultPartner?.emailAccount??currentUser?.preferred_username,
    accountId: defaultPartner?.accountId??"",
    type: defaultPartner?.type??"",
    name: defaultPartner?.name??"",
    mission: defaultPartner?.mission??"",
    based: defaultPartner?.based??"",
    numberOfSalary: defaultPartner?.numberOfSalary??undefined,
    numberOfVolunteers: defaultPartner?.numberOfVolunteers??"",
    registrationNumber: defaultPartner?.registrationNumber??"",
    webSite: defaultPartner?.webSite??"",
    structureCreationDate: defaultPartner?.structureCreationDate??"",
    founderName: defaultPartner?.founderName??"",
    postalCode: defaultPartner?.postalCode??"",
    country: defaultPartner?.country??"",
    city: defaultPartner?.city??"",
    department: defaultPartner?.department??"",
    managementBroads: defaultPartner?.managementBroads??"",
    managementBroadsMother: defaultPartner?.managementBroadsMother??"",
    isSubjectLitigationCourtAward: defaultPartner?.isSubjectLitigationCourtAward??false,
    hasOrganisationDefinedEthicsCompliance: defaultPartner?.hasOrganisationDefinedEthicsCompliance??false,
    isPeoplePoliticallyExposedInStructure: defaultPartner?.isPeoplePoliticallyExposedInStructure??false,
    gouvernmentMemberIsOnManagementBoard: defaultPartner?.gouvernmentMemberIsOnManagementBoard??false,
    hasRelationWithGouvernmentOrState: defaultPartner?.hasRelationWithGouvernmentOrState??false,
    previousSupportFromFoundation: defaultPartner?.previousSupportFromFoundation??"", 
    organisation: defaultPartner?.organisation??"",
    adresse: defaultPartner?.adresse??""
  } as PartnerForCreationDto | PartnerForUpdateDto);

  // Current lang
  let lang = i18n.language;

  const steps = [
    { title: 'Infos 1' },
    { title: 'Infos 2' },
    { title: 'Infos 3' },
  ];

  const [activeStep, setActiveStep ] = useState(0);


  // handle default Partner for update
  useEffect(()=>{
    if(defaultPartner && defaultPartner?.id) setPartner(defaultPartner);
  },[defaultPartner]);


  const submitPartner = (data: PartnerForCreationDto | PartnerForUpdateDto,
    formikHelpers: FormikHelpers<PartnerForCreationDto | PartnerForUpdateDto>) => {
    data.emailAccount = currentUser?.preferred_username;
    data.managementBroadsMother = data.managementBroadsMother.toString();
  
    defaultPartner && defaultPartner?.id ? updatePartner(data, formikHelpers) : createPartner(data, formikHelpers) ;  
  }

  const createPartnerApi = useAddPartner();
  function createPartner(data: PartnerForCreationDto | PartnerForUpdateDto,
    formikHelpers: FormikHelpers<PartnerForCreationDto | PartnerForUpdateDto>) {
    
    createPartnerApi
      .mutateAsync(data)
      .then((response) => {
        Notifications.success("Structure créé avec succès");
        // go to the preview page
        formikHelpers.setSubmitting(false);
        navigate("/");
      })
      .catch((e) => {
        Notifications.error("Erreur lors de la création de la structure.");
        formikHelpers.setSubmitting(false);
        console.error(e);
      });
  }

  const updatePartnerApi = useUpdatePartner();
  function updatePartner(data: PartnerForCreationDto | PartnerForUpdateDto,
    formikHelpers: FormikHelpers<PartnerForCreationDto | PartnerForUpdateDto>) {
    
    const id = defaultPartner?.id;
    if (id === null || id === undefined) return;

    updatePartnerApi
      .mutateAsync({ id, data })
      .then(() => {
        Notifications.success("Structure mise à jour avec succès.");
        
        // go to the preview page
        formikHelpers.setSubmitting(false);
        navigate("/");
      })
      .catch((e) => {
        formikHelpers.setSubmitting(false);
        Notifications.error("Erreur lors de la mise à jour de la structure.");
      });
  }

  function getSectionComponent(formikProps: FormikProps) {

    return (
      <>
        <div hidden={ activeStep !== 0 }>
            <Infos1 formikProps={formikProps} />
        </div>
        <div hidden={ activeStep !== 1 }>
            <Infos2 formikProps={formikProps} />
        </div>
        <div hidden={ activeStep !== 2 }>
            <Infos3 formikProps={formikProps} />
        </div>
      </>
    );

    /* switch(activeStep) {
      case 0: return <Infos1 />;
      case 1: return <Infos2 />;
      case 2: return <Infos3 />;
      default: return null;
    } */
  }

  let based = lang === 'en' ? [ { label: "Cameroon", value: "Cameroon" }, { label: "Abroad", value:"Abroad" }] : [ { label: "Cameroun", value: "Cameroon" }, { label: "A l'étranger", value:"Abroad" }];

  let organisation = [{ label: t('structure.ong'), value: t('structure.ong') }, { label: t('structure.association'), value: t('structure.association') }, { label: t('structure.orgEtat'), value: t('structure.orgEtat') }, { label: t('structure.other'), value: t('structure.other') }];

  const Infos1 = ({ formikProps }: InfosProps)=> {
    
    return (
      <>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="name" setFieldValue={formikProps.setFieldValue} label={ t('structure.name') } value={formikProps?.values?.name == "" ? partner.name : formikProps?.values?.name} required/>
          </div>
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="type" setFieldValue={formikProps.setFieldValue} label={ t('structure.type') } value={formikProps?.values?.type == "" ? partner.type : formikProps?.values?.type} required />
          </div>
        </div>
  
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="mission" setFieldValue={formikProps.setFieldValue} label={ t('structure.mission') } value={formikProps?.values?.mission == "" ? partner.mission : formikProps?.values?.mission} required />
          </div>
          <div className="col-12 col-md-6">
            {/* <FormFieldInput name="based" errors={errors} setFieldValue={setFieldValue} value={values.based == "" ? partner.based : values.based} label={"Localisation"}  /> */}
            <FormField2Select isMulti={false} setFieldValue={formikProps.setFieldValue} options={based} name="based" label={ t('structure.based') } value={formikProps?.values?.based == "" ? partner.based : formikProps?.values?.based} required />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="registrationNumber" setFieldValue={formikProps.setFieldValue} label={ t('structure.registrationNumber') } value={formikProps?.values?.registrationNumber == "" ? partner.registrationNumber : formikProps?.values?.registrationNumber}  required />
          </div>
          
          <div className="col-12 col-md-6">
            <FormFieldInput type="number" name="numberOfSalary" setFieldValue={formikProps.setFieldValue} label={ t('structure.numberOfSalary') } value={formikProps?.values?.numberOfSalary == undefined ? partner.numberOfSalary : formikProps?.values?.numberOfSalary} required />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text"  name="numberOfVolunteers" setFieldValue={formikProps.setFieldValue} label={t('structure.numberOfVolunteers') } value={formikProps?.values?.numberOfVolunteers == "" ? partner.numberOfVolunteers : formikProps?.values?.numberOfVolunteers} required />
          </div>
          <div className="col-12 col-md-6">
            <FormFieldInput type="date" name="structureCreationDate" setFieldValue={formikProps.setFieldValue} label={ t('structure.creationDate') } value={formikProps?.values?.structureCreationDate == "" ? partner.structureCreationDate : formikProps?.values?.structureCreationDate} required />
          </div>
        </div>
      </>
    );
  }
  
  const Infos2 = ({ formikProps }: InfosProps)=> {
    return (
      <>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="founderName" setFieldValue={formikProps.setFieldValue} label={ t('structure.founderName') } value={formikProps?.values?.founderName == "" ? partner.founderName : formikProps?.values?.founderName} required  />
          </div>
          <div className="col-12 col-md-6">
            <FormFieldCountrySelect name="country" lang={lang} setFieldValue={formikProps.setFieldValue} label={ t('structure.country') } value={formikProps?.values?.country == "" ? partner.country : formikProps?.values?.country } required />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="department" setFieldValue={formikProps.setFieldValue} label={ t('structure.department') } value={formikProps?.values?.department == "" ? partner.department : formikProps?.values?.department} required />
          </div>
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="city" setFieldValue={formikProps.setFieldValue} label={ t('structure.cityr') } value={formikProps?.values?.city == "" ? partner.city : formikProps?.values?.city} required />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="postalCode" setFieldValue={formikProps.setFieldValue} label={ t('structure.postalCode') } value={formikProps?.values?.postalCode == "" ? partner.postalCode : formikProps?.values?.postalCode} required />
          </div>
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="webSite" setFieldValue={formikProps.setFieldValue} label={ t('structure.siteweb') } value={formikProps?.values?.webSite == "" ? partner.webSite : formikProps?.values?.webSite} required />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldTextArea name="managementBroads" setFieldValue={formikProps.setFieldValue} label={ t('structure.managementBoards') } value={formikProps?.values?.managementBroads == "" ? partner.managementBroads : formikProps?.values?.managementBroads}  />
          </div>
          <div className="col-12 col-md-6">
            <FormFieldTextArea name="previousSupportFromFoundation" setFieldValue={formikProps.setFieldValue} label={ t('structure.previousSuportFromFoundation') } value={formikProps?.values?.previousSupportFromFoundation == "" ? partner.previousSupportFromFoundation : formikProps?.values?.previousSupportFromFoundation} />
          </div>
        </div>
      </>
    );
  }
  
  const Infos3 = ({ formikProps }: InfosProps)=> {
  
    return  (
      <>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="number" name="managementBroadsMother" setFieldValue={formikProps.setFieldValue} label={ t('structure.managementBoardsOfMother') } value={formikProps?.values?.managementBroadsMother ? formikProps?.values?.managementBroadsMother : partner.managementBroadsMother } />
          </div>
          <div className="col-12 col-md-6">
            <FormField2Select isMulti={false} setFieldValue={formikProps.setFieldValue} options={organisation} name="organisation" label={ t('structure.organisation') } value={formikProps?.values?.organisation == "" ? partner.organisation : formikProps?.values?.organisation} required />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormFieldInput type="text" name="adresse" setFieldValue={formikProps.setFieldValue} label={ t('structure.adresse') } value={formikProps?.values?.adresse == "" ? partner.adresse : formikProps?.values?.adresse} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-12">
            <FormFieldCheckbox name="hasOrganisationDefinedEthicsCompliance" label={ t('structure.hasOrganisationDefinedEthicsCompliance') } setFieldValue={formikProps.setFieldValue}  value={ partner.hasOrganisationDefinedEthicsCompliance }/>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-12">
            <FormFieldCheckbox name="isPeoplePoliticallyExposedInStructure" label={ t('structure.isPeoplePoliticallyExposedInStructure') } setFieldValue={formikProps.setFieldValue} value={ partner.isPeoplePoliticallyExposedInStructure } />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-12">
            <FormFieldCheckbox name="gouvernmentMemberIsOnManagementBoard" label={ t('structure.gouvernmentMemberIsOnManagementBoad') } setFieldValue={formikProps.setFieldValue} value={ partner.gouvernmentMemberIsOnManagementBoard } />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-12">
            <FormFieldCheckbox name="hasRelationWithGouvernmentOrState" label={ t('structure.hasRelationWithGouvernmentOrState') } setFieldValue={formikProps.setFieldValue} value={ partner.hasRelationWithGouvernmentOrState } />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-12">
            <FormFieldCheckbox name="isSubjectLitigationCourtAward" label={ t('structure.isSubjectLitigationCourtAward') } setFieldValue={formikProps.setFieldValue} value={ partner.isSubjectLitigationCourtAward ? partner.isSubjectLitigationCourtAward : formikProps?.values?.isSubjectLitigationCourtAward } />
          </div>
        </div>
      </>
    );
  }



  
  return (
  
      <Formik
        initialValues={partner}
        validationSchema={partnerValidationSchema}
        onSubmit={(values,formikHelpers) => submitPartner(values, formikHelpers) }
        // validateOnChange={false}
        validateOnMount={false}
        // initialStatus={true}
        enableReinitialize={false} // Réinitialise les valeurs et désactive la validation lors du premier rendu
      >
        {({ isValid, dirty, errors, isSubmitting, values, setFieldValue, handleReset }) => {
          console.log("isValid ", isValid);
          console.log("dirty ", dirty);
          console.log("ERRORS ", errors);
          return (
            <Form>
              <div>
                {isSubmitting && <div className="lds-roller"></div>}
                
                    <Stepper
                      steps={steps}
                      activeStep={activeStep}/>
                      <div style={{ padding: "20px" }}>
                         { getSectionComponent({ errors, isSubmitting, values, setFieldValue })  }
                      </div>    
              </div> 

              <hr/>
              <div className="d-flex justify-content-end">
                  { (activeStep !== 0 ) // && activeStep !== steps.length - 1
                    && 
                    (<Button 
                          type='button'
                          onClick={() => { setActiveStep(activeStep - 1); } } 
                          children={ t('app.previous') }
                          style={{
                            marginRight:"10px",
                            border: "1px solid #979797",
                            color: "#757575",
                            backgroundColor: "#fff",
                            width: "100px !important"
                          }}
                          sx={{
                            "&.MuiButton-root": {
                              textTransform: 'none',
                              height: "32px",
                              width: "100px",
                            },
                            "&.Mui-disabled": {
                              color: "white",
                            }
                          }}
                        />)
                }
                { activeStep !== steps.length - 1
                  && 
                  (<Button 
                    type='button'
                    onClick={(e) => { setActiveStep(activeStep + 1); } } 
                    children={ t('app.next') } 
                    style={{
                        marginLeft:"10px",
                        color: "#fff",
                        backgroundColor: "#FF7900",
                        width: "100px !important"
                    }}
                    sx={{
                      "&.MuiButton-root": {
                        textTransform: 'none',
                        height: "32px",
                        width: "100px",
                      },
                      "&.Mui-disabled": {
                        color: "white",
                      }
                    }}
                    />)
                }
                { activeStep === steps.length - 1
                  &&
                  (<LoadingButton 
                      type='submit' 
                      variant="contained"
                      disabled={!(isValid && dirty)}
                      className="px-1"
                      children={ t('app.save') }
                      loading={isSubmitting}
                      style={{
                        marginLeft:"10px",
                        color: "#fff",
                        backgroundColor: "#FF7900",
                        width: "100px !important"
                      }}
                      sx={{
                        "&.MuiButton-root": {
                          textTransform: 'none',
                          height: "32px",
                          width: "100px",
                        },
                        "&.Mui-disabled": {
                          color: "white",
                        }
                      }}
                    />
                  )
                }

              </div>

            </Form>
          );
        }}
      </Formik>
    );
}



export default PartnerForm;